import { render, staticRenderFns } from "./AutoClose.vue?vue&type=template&id=ddd2fc98&"
import script from "./AutoClose.vue?vue&type=script&lang=ts&"
export * from "./AutoClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports